import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, viewportConfig } from '@/lib/animations';

const differentiators = [
  {
    number: '01',
    title: 'Government & Business Specialists',
    description: 'We understand both sectors. No learning curve, just expertise from day one.',
  },
  {
    number: '02',
    title: 'Transparent, Data-Driven Reporting',
    description: 'Real-time dashboards show exactly where your dollars go. No black boxes.',
  },
  {
    number: '03',
    title: 'Certified Small Business Partner',
    description: 'SDVOSB and MBO certified. Meet your diversity requirements while getting exceptional results.',
  },
  {
    number: '04',
    title: 'Extension of Your Team',
    description: 'We attend your meetings, align with your mission, and integrate with your workflow.',
  },
];

export function WhySection() {
  return (
    <section id="why" className="relative py-12 sm:py-14 md:py-16 lg:py-20 bg-navy-deep overflow-hidden">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={viewportConfig}
        variants={staggerContainer}
        className="container relative z-10 mx-auto px-5 sm:px-6"
      >
        <motion.div variants={fadeInUp} className="text-center mb-12 md:mb-16">
          <span className="text-orange font-semibold text-xs sm:text-sm tracking-widest uppercase mb-2 sm:mb-3 block">
            Why Choose Us
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight">
            A Different Approach to{' '}
            <span className="text-teal-light">Digital Advertising</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-10">
          {differentiators.map((item, index) => (
            <motion.div
              key={item.number}
              variants={fadeInUp}
              className="relative pl-16 sm:pl-20"
            >
              <span 
                className="absolute left-0 top-0 text-5xl sm:text-6xl font-bold text-orange/50 select-none leading-none"
                style={{ textShadow: '0 0 30px hsl(28 54% 51% / 0.4)' }}
              >
                {item.number}
              </span>
              <div className="relative z-10">
                <h3 className="text-lg sm:text-xl font-semibold text-white mb-2">
                  {item.title}
                </h3>
                <div className="w-10 h-0.5 bg-orange mb-3" />
                <p className="text-white/60 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
